import React from "react";
import Layoute from "../components/layoute";
import fetch from "unfetch";
import moment from "moment";
import {
  Form,
  Alert,
  Upload,
  Menu,
  notification,
  Input,
  Select,
  Card,
  Col,
  Spin,
  Row,
  Button,
  Icon,
  Divider,
  Table,
  Dropdown,
  Tooltip,
  Modal,
  Badge,
  Checkbox,
} from "antd";
const FormItem = Form.Item;
const confirm = Modal.confirm;
const Search = Input.Search;
const Option = Select.Option;

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      columns: [
        {
          title: "",
          width: 100,
          dataIndex: "infos",
          key: "infos",
          fixed: "left",
          render: (t, record) => {
            return (
              <div>
                {record.admin ? (
                  <Tooltip title="Administrateur">
                    <Button
                      disabled
                      style={{ marginRight: "5px", color: "#64B5F6" }}
                      size="small"
                      shape="circle"
                      icon="safety"
                    />
                  </Tooltip>
                ) : (
                  ""
                )}
                {record.group &&
                record.group.indexOf(
                  this.state.groupList.filter((f) => {
                    return f.slug == "membre-ca";
                  })[0]._id
                ) !== -1 ? (
                  <Tooltip title="Membre CA">
                    <Button
                      disabled
                      style={{ marginRight: "5px", color: "#64B5F6" }}
                      size="small"
                      shape="circle"
                      icon="contacts"
                    />
                  </Tooltip>
                ) : (
                  ""
                )}
                {record.group &&
                record.group.indexOf(
                  this.state.groupList.filter((f) => {
                    return f.slug == "membre-du-bureau";
                  })[0]._id
                ) !== -1 ? (
                  <Tooltip title="Membre du bureau">
                    <Button
                      disabled
                      style={{ marginRight: "5px", color: "#64B5F6" }}
                      size="small"
                      shape="circle"
                      icon="team"
                    />
                  </Tooltip>
                ) : (
                  ""
                )}
                {/*
                <Tooltip title="Plus d'informations">
                  <Button onClick={() => this.setState({infoModal: true, selectedUser: record})} size="small" shape="circle" icon="info" />
                </Tooltip>
		*/}
              </div>
            );
          },
        },
        {
          title: "Entreprise",
          width: 300,
          dataIndex: "company.name",
          key: "company.name",
          fixed: "left",
          render: (t, record) => {
            return (
              <div>
                <Badge
                  status={
                    record.company.status == "actif" ? "success" : "warning"
                  }
                />{" "}
                <b>{record.company.name}</b>
              </div>
            );
          },
        },
        {
          title: "Nom Prénom",
          width: 250,
          dataIndex: "lastname",
          key: "lastname",
          fixed: "left",
          render: (text, record) =>
            `${record.lastname ? record.lastname : ""} ${
              record.firstname ? record.firstname : ""
            }`,
        },
        // {
        //   title: "Prénom",
        //   width: 200,
        //   dataIndex: "firstname",
        //   key: "firstname",
        //   fixed: "left",
        // },
        {
          title: "Email",
          dataIndex: "email",
          key: "email",
          render: (text) => (text && text.toLowerCase()) || "",
        },
        {
          title: "Adresse",
          dataIndex: "company.address",
          key: "company.address",
        },
        { title: "Ville", dataIndex: "company.city" },
        {
          title: "Newsletter",
          dataIndex: "newsletter",
          render: (text, record) => {
            return record.newsletter ? "Oui" : "Non";
          },
        },
        {
          title: "Téléphone",
          dataIndex: "phone",
          render: (text, record) => {
            return record.phone ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                {record.phone.fixe ? <span>{record.phone.fixe}</span> : ""}
                {record.phone.port ? <span>{record.phone.port}</span> : ""}
              </div>
            ) : (
              ""
            );
          },
        },
        {
          title: "Actions",
          dataIndex: "operation",
          fixed: "right",
          width: 100,
          render: (text, record) => {
            const { editable } = record;
            return (
              <div
                style={{ display: "flex", alignItems: "center" }}
                className="editable-row-operations"
              >
                {this.props.user._id !== record._id
                  ? [
                      <Tooltip title="Editer">
                        <Button
                          onClick={() =>
                            this.setState({
                              editModal: true,
                              selectedUser: {
                                ...record,
                                phone: record.phone || {},
                              },
                              fileList: [],
                              preview: "",
                              typeModal: "edit",
                            })
                          }
                          style={{ marginRight: "5px" }}
                          shape="circle"
                          icon="form"
                        />
                      </Tooltip>,
                      <Tooltip title="Supprimer">
                        <Button
                          onClick={() => this.showConfirm(record._id)}
                          type="danger"
                          shape="circle"
                          icon="close"
                        />
                      </Tooltip>,
                    ]
                  : ""}
              </div>
            );
          },
        },
      ],
      data: [],
      loading: true,
    };
    this.filterData = this.filterData.bind(this);
    this.searchData = this.searchData.bind(this);
    this.actionClick = this.actionClick.bind(this);
    this.createGroup = this.createGroup.bind(this);
    this.updateUser = this.updateUser.bind(this);
    this.saveUser = this.saveUser.bind(this);
    this.removeUser = this.removeUser.bind(this);
    this.removeCompany = this.removeCompany.bind(this);
    this.showCompanyDeleteConfirm = this.showCompanyDeleteConfirm.bind(this);
    this.loadDeletedCompanies = this.loadDeletedCompanies.bind(this);
    this.restoreCompany = this.restoreCompany.bind(this);
    this.showCompanyRestoreConfirm = this.showCompanyRestoreConfirm.bind(this);
    this.export = this.export.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  sortAlphabetically(a, b) {
    if (a > b) {
      return -1;
    }
    if (a < b) {
      return 1;
    }
    return 0;
  }

  loadData() {
    fetch("/api/user", {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          loading: false,
          data: data.users,
          filterData: data.users,
          groupList: data.groups,
          update: data.update,
        });
        fetch("/api/company", {
          credentials: "include",
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": localStorage.getItem("x-access-token"),
          },
        })
          .then((res) => res.json())
          .then((data) => {
            this.setState({
              companyList: data.companies.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
              }),
            });
          });
      });
  }

  componentDidMount() {
    this.loadData();
  }

  showConfirm(id) {
    confirm({
      title: "Etes-vous certain de vouloir supprimer cet utilisateur ?",
      okText: "Supprimer",
      cancelText: "Annuler",
      onCancel: () => {},
      onOk: () => {
        this.removeUser(id);
      },
    });
  }

  updateUser() {
    if (
      this.state.selectedUser &&
      this.state.selectedUser.company &&
      this.state.selectedUser.company.status === "deleted"
    ) {
      confirm({
        title: "Etes-vous certain de vouloir supprimer cette entreprise ?",
        content:
          "Cette action marquera l’entreprise comme supprimée et la retirera des listes visibles.",
        okText: "Supprimer",
        okType: "danger",
        cancelText: "Annuler",
        onOk: () => {
          this.saveUser();
        },
      });
      return;
    }

    this.saveUser();
  }

  saveUser() {
    let formData = new FormData();

    Object.keys(this.state.selectedUser).map((k) => {
      formData.append(k, JSON.stringify(this.state.selectedUser[k]));
    });

    if (this.state.fileList.length > 0) {
      formData.append("logo", this.state.fileList[0]);
    }

    fetch("/api/user", {
      credentials: "include",
      method: this.state.typeModal == "edit" ? "PUT" : "POST",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
      },
      body: formData,
    })
      .then((response) =>
        response.json().then((body) => ({
          ok: response.ok,
          body,
        }))
      )
      .then(({ ok, body }) => {
        if (!ok || body.success === false) {
          notification["error"]({
            message: "Modification impossible",
            description:
              body.message || "La fiche n’a pas pu être enregistrée.",
          });
          return;
        }

        this.setState({
          editModal: false,
          loading: true,
          update: {
            updatedBy: JSON.parse(localStorage.getItem("user")),
            updatedAt: new Date(),
          },
        });
        this.loadData();

        notification["success"]({
          message:
            (this.state.typeModal == "edit" ? "Modification" : "Création") +
            " éffectuée",
          description: "Les modifications ont été appliquées",
        });
      });
  }

  getCompanyUserCount(companyId) {
    return this.state.filterData.filter(
      (user) => user.company && user.company._id === companyId
    ).length;
  }

  showCompanyDeleteConfirm(company) {
    const userCount = this.getCompanyUserCount(company._id);

    confirm({
      title: "Supprimer cette entreprise ?",
      content:
        "L’entreprise « " +
        company.name +
        " » sera retirée des listes visibles. " +
        userCount +
        " utilisateur(s) rattaché(s) seront également marqués comme supprimés. Les données restent conservées en base pour historique.",
      okText: "Supprimer l’entreprise",
      okType: "danger",
      cancelText: "Annuler",
      onOk: () => {
        this.removeCompany(company._id);
      },
    });
  }

  loadDeletedCompanies() {
    this.setState({ deletedCompaniesModal: true, deletedCompaniesLoading: true });

    fetch("/api/company/deleted", {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          deletedCompaniesLoading: false,
          deletedCompanies: data.companies || [],
        });
      });
  }

  showCompanyRestoreConfirm(company) {
    confirm({
      title: "Restaurer cette entreprise ?",
      content:
        "L’entreprise « " +
        company.name +
        " » sera remise en statut passif et ses utilisateurs seront à nouveau visibles.",
      okText: "Restaurer",
      cancelText: "Annuler",
      onOk: () => {
        this.restoreCompany(company._id);
      },
    });
  }

  restoreCompany(companyId) {
    this.setState({ companyRestoreLoading: companyId });

    fetch("/api/company/" + companyId + "/restore", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
      body: JSON.stringify({ status: "passif" }),
    })
      .then((response) =>
        response.json().then((body) => ({
          ok: response.ok,
          body,
        }))
      )
      .then(({ ok, body }) => {
        this.setState({ companyRestoreLoading: null });

        if (!ok || body.success === false) {
          notification["error"]({
            message: "Restauration impossible",
            description:
              body.message || "L’entreprise n’a pas pu être restaurée.",
          });
          return;
        }

        notification["success"]({
          message: "Entreprise restaurée",
          description:
            "L’entreprise est à nouveau visible avec le statut passif.",
        });

        this.setState({
          deletedCompanies: this.state.deletedCompanies.filter(
            (company) => company._id !== companyId
          ),
          loading: true,
        });
        this.loadData();
      });
  }

  removeCompany(companyId) {
    this.setState({ companyDeleteLoading: true });

    fetch("/api/company/" + companyId, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
        "Content-Type": "application/json",
      },
    })
      .then((response) =>
        response.json().then((body) => ({
          ok: response.ok,
          body,
        }))
      )
      .then(({ ok, body }) => {
        this.setState({ companyDeleteLoading: false });

        if (!ok || body.success === false) {
          notification["error"]({
            message: "Suppression impossible",
            description:
              body.message || "L’entreprise n’a pas pu être supprimée.",
          });
          return;
        }

        notification["success"]({
          message: "Entreprise supprimée",
          description:
            "L’entreprise et ses utilisateurs ont été retirés des listes visibles.",
        });

        this.setState({ editModal: false, loading: true });
        this.loadData();
      });
  }

  removeUser(id) {
    fetch("/api/user/status", {
      method: "POST",
      credentials: "include",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        demande: id,
        status: "deleted",
        update: true,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        let data = this.state.data;
        let filterData = this.state.filterData;

        data.splice(
          this.state.data.findIndex((f) => {
            return f._id == id;
          }),
          1
        );
        filterData.splice(
          this.state.filterData.findIndex((f) => {
            return f._id == id;
          }),
          1
        );

        this.setState({
          data: data,
          filterData: filterData,
        });
      });
  }

  filterData(key) {
    this.setState({
      filtered: true,
    });
    if (key.indexOf("passif") == -1 && key.indexOf("actif") == -1) {
      this.setState({
        data: this.state.filterData.filter((f) => {
          return f.group.indexOf(key) !== -1;
        }),
      });
    } else {
      const toFilter = key.split(",");
      this.setState({
        data: this.state.filterData.filter((f) => {
          return toFilter.indexOf(f.company.status) !== -1;
        }),
      });
    }
  }

  export(data) {
    var csv = "Société; Nom; Prénom; Email; Adresse; Ville; Téléphone\n";
    data
      .sort(function (a, b) {
        if (a.company.name < b.company.name) return -1;
        if (a.company.name > b.company.name) return 1;
        return 0;
      })
      .map((m) => {
        csv += `${m.company.name}; ${m.lastname}; ${m.firstname}; ${m.email}; ${
          m.company.address
        }; ${m.company.city}; ${
          m.phone
            ? (m.phone.fixe ? m.phone.fixe : "") +
              (m.phone.fixe && m.phone.port ? " - " : "") +
              (m.phone.port ? m.phone.port : "")
            : ""
        }\n`;
      });
    this.setState({
      csv: window.URL.createObjectURL(
        new Blob(["\ufeff", csv], {
          type: "text/csv;charset=UTF-8",
          encoding: "UTF-8",
        })
      ),
    });
  }

  onRemove(file) {
    this.setState({
      fileList: [],
      preview: "",
    });
  }

  beforeUpload(file) {
    var fr = new FileReader();
    fr.onload = () => {
      this.setState({
        preview: fr.result,
      });
    };
    fr.readAsDataURL(file);

    this.setState({
      fileList: [file],
    });

    return false;
  }

  searchData(val) {
    const searchTerm = val.trim().toLowerCase();

    this.setState({
      filtered: true,
      data: this.state.filterData.filter((f) => {
        const company = f.company || {};
        const phone = f.phone || {};
        const searchableFields = [
          f.firstname,
          f.lastname,
          f.email,
          phone.fixe,
          phone.port,
          company.name,
          company.address,
          company.city,
          company.contact,
          company.phone,
          company.website,
        ];

        return searchableFields
          .filter((field) => typeof field === "string")
          .join(" ")
          .toLowerCase()
          .indexOf(searchTerm) !== -1;
      }),
    });
  }

  actionClick(key) {
    console.log(key);
    if (key == "group") {
      this.setState({
        groupModal: true,
      });
    } else if (key == "create") {
      this.setState({
        editModal: true,
        typeModal: "create",
        selectedUser: {
          company: {},
          phone: {},
          newsletter: true,
        },
      });
    } else if (key == "deleted-companies") {
      this.loadDeletedCompanies();
    } else if (key == "export") {
      this.setState({
        exportModal: true,
      });
    }
  }

  createGroup() {
    fetch("/api/user/group", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
      body: JSON.stringify({ title: this.state.groupName }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          notification["success"]({
            message: "Création éffectué",
            description: "Le groupe a été créé avec succès",
          });
          this.setState({
            groupList: res.groups,
          });
        } else {
          notification["error"]({
            message: "Erreur",
            description: "Une erreur est survenue, merci de réessayer",
          });
        }
        this.setState({
          groupModal: false,
        });
      });
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const filterMenu = (
      <Menu
        onClick={(item) => {
          this.filterData(item.key);
        }}
      >
        <Menu.Item key="actif,passif">
          <Badge status="default" /> Tous
        </Menu.Item>
        <Menu.Item key="actif">
          <Badge status="success" /> Actifs
        </Menu.Item>
        <Menu.Item key="passif">
          <Badge status="warning" /> Passifs
        </Menu.Item>
        <Menu.Divider />
        {this.state.groupList
          ? this.state.groupList.map((g) => {
              return (
                <Menu.Item key={g._id}>
                  <Badge status="default" /> {g.title}
                </Menu.Item>
              );
            })
          : ""}
      </Menu>
    );

    const actionMenu = (
      <Menu
        onClick={(item) => {
          this.actionClick(item.key);
        }}
      >
        <Menu.Item key="group">
          <Icon style={{ marginRight: "5px" }} type="folder" /> Gestion des
          groupes
        </Menu.Item>
        <Menu.Item key="create">
          <Icon style={{ marginRight: "5px" }} type="user" /> Ajouter une fiche
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="deleted-companies">
          <Icon style={{ marginRight: "5px" }} type="rollback" /> Entreprises
          supprimées
        </Menu.Item>
        <Menu.Item key="export">
          <Icon style={{ marginRight: "5px" }} type="download" /> Expoter les
          données
        </Menu.Item>
      </Menu>
    );

    return (
      <React.Fragment>
        <h5>Entreprises</h5>
        <p>Liste des entreprises du Parc d'affaires</p>
        <Divider />
        {this.state.loading ? (
          <div
            style={{
              height: "500px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <div>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              {this.state.update ? (
                <div
                  style={{
                    flex: 1,
                    marginLeft: "5px",
                    fontSize: "12px",
                    color: "#a8a8a8",
                  }}
                  className="custom-input"
                >
                  Dernière modification :{" "}
                  {this.state.update.updatedBy.firstname +
                    " " +
                    this.state.update.updatedBy.lastname.toUpperCase()}{" "}
                  <br />
                  Le{" "}
                  {moment(this.state.update.updatedAt).format(
                    "DD/MM/YYYY à HH:mm"
                  )}
                </div>
              ) : (
                ""
              )}
              <div
                style={{
                  flex: 1,
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Search
                  placeholder="Rechercher"
                  onSearch={(value) => this.searchData(value)}
                  style={{ width: 200 }}
                />
                {this.state.filtered ? (
                  <Button
                    style={{ marginLeft: "10px" }}
                    type="danger"
                    onClick={() => {
                      this.setState({
                        data: this.state.filterData,
                        filtered: false,
                      });
                    }}
                  >
                    Réinitiliaser les filtres
                  </Button>
                ) : (
                  ""
                )}
                <Dropdown trigger={["click"]} overlay={filterMenu}>
                  <Button style={{ marginLeft: "10px" }}>
                    Filtrer par <Icon type="down" />
                  </Button>
                </Dropdown>
                <Dropdown trigger={["click"]} overlay={actionMenu}>
                  <Button type="primary" style={{ marginLeft: "10px" }}>
                    Actions <Icon type="down" />
                  </Button>
                </Dropdown>
              </div>
            </div>
            <Modal
              visible={this.state.groupModal}
              title="Groupe d'utilisateurs"
              onOk={() => this.setState({ groupModal: false })}
              onCancel={() => this.setState({ groupModal: false })}
              footer={[
                <Button
                  disabled={
                    !this.state.groupName ||
                    this.state.groupName.trim().length < 5
                  }
                  key="submit"
                  type="primary"
                  onClick={() => this.createGroup()}
                >
                  Valider
                </Button>,
                <Button
                  key="submit"
                  onClick={() => this.setState({ groupModal: false })}
                >
                  Annuler
                </Button>,
              ]}
            >
              <div style={{ marginBottom: "20px" }}>
                <b>Groupes existant</b>
                <Table
                  pagination={false}
                  bordered={true}
                  columns={[
                    {
                      title: "Nom",
                      key: "title",
                      dataIndex: "title",
                    },
                    {
                      title: "Identifiant",
                      key: "slug",
                      dataIndex: "slug",
                    },
                  ]}
                  dataSource={this.state.groupList}
                />
              </div>
              <div>
                <b>Indiquez le nom du groupe à créer</b>
                <Input
                  type="text"
                  value={this.state.groupName}
                  onChange={(e) => {
                    this.setState({ groupName: e.target.value });
                  }}
                />
              </div>
            </Modal>
            <Modal
              visible={this.state.exportModal}
              title="Export des données"
              onCancel={() => this.setState({ exportModal: false, csv: false })}
              footer={[
                this.state.csv
                  ? [
                      <Button
                        onClick={() =>
                          this.setState({ exportModal: false, csv: false })
                        }
                        key="submit"
                      >
                        Annuler
                      </Button>,
                      <a
                        href={this.state.csv}
                        download={"Le-Hub-Bezannes-" + moment().format("DDMMYY") + ".csv"}
                        onClick={() => this.setState({ csv: false })}
                        style={{ marginLeft: "10px", color: "#fff" }}
                        className="ant-btn ant-btn-primary"
                      >
                        Télécharger
                      </a>,
                    ]
                  : [
                      <Button
                        onClick={() => this.export(this.state.filterData)}
                        key="submit"
                        type="danger"
                      >
                        Tout exporter
                      </Button>,
                      <Button
                        onClick={() => this.export(this.state.data)}
                        type="primary"
                        key="submit"
                      >
                        Exporter le filtre actuel
                      </Button>,
                    ],
              ]}
            >
              <p>
                Vous pouvez exporter les données du filtre actuel ou bien
                choisir d'exporter toutes les données existantes
              </p>
            </Modal>
            <Modal
              visible={this.state.deletedCompaniesModal}
              title="Entreprises supprimées"
              onCancel={() => this.setState({ deletedCompaniesModal: false })}
              footer={[
                <Button
                  key="close"
                  onClick={() => this.setState({ deletedCompaniesModal: false })}
                >
                  Fermer
                </Button>,
              ]}
              width={800}
            >
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
                message="Restauration d’entreprise"
                description="La restauration remet l’entreprise en statut passif et rend à nouveau visibles les utilisateurs rattachés."
              />
              <Table
                rowKey="_id"
                loading={this.state.deletedCompaniesLoading}
                pagination={{ pageSize: 6 }}
                locale={{ emptyText: "Aucune entreprise supprimée" }}
                dataSource={this.state.deletedCompanies || []}
                columns={[
                  {
                    title: "Entreprise",
                    dataIndex: "name",
                    key: "name",
                  },
                  {
                    title: "Ville",
                    dataIndex: "city",
                    key: "city",
                  },
                  {
                    title: "Date de suppression",
                    dataIndex: "updatedAt",
                    key: "updatedAt",
                    render: (text) =>
                      text ? moment(text).format("DD/MM/YYYY à HH:mm") : "-",
                  },
                  {
                    title: "Action",
                    key: "action",
                    width: 140,
                    render: (text, record) => (
                      <Button
                        type="primary"
                        loading={this.state.companyRestoreLoading === record._id}
                        onClick={() => this.showCompanyRestoreConfirm(record)}
                      >
                        Restaurer
                      </Button>
                    ),
                  },
                ]}
              />
            </Modal>
            {this.state.selectedUser ? (
              <div>
                <Modal
                  visible={this.state.editModal}
                  title={
                    <h5 style={{ margin: 0 }}>
                      {this.state.typeModal == "edit" ? "Edition" : "Création"}{" "}
                      d'une fiche
                    </h5>
                  }
                  width={1100}
                  onOk={() => this.setState({ editModal: false })}
                  onCancel={() => this.setState({ editModal: false })}
                  footer={[
                    <Button
                      onClick={() => this.updateUser()}
                      key="submit"
                      type="primary"
                    >
                      {this.state.typeModal == "edit" ? "Modifier" : "Créer"}
                    </Button>,
                    <Button
                      onClick={() => this.setState({ editModal: false })}
                      key="submit"
                    >
                      Annuler
                    </Button>,
                  ]}
                >
                  <Form className="table-modal">
                    <div className="user">
                      <h5>Utilisateur</h5>
                      <hr />
                      <FormItem {...formItemLayout} label="Nom">
                        <Input
                          value={this.state.selectedUser.lastname}
                          onChange={(e) => {
                            this.setState({
                              selectedUser: {
                                ...this.state.selectedUser,
                                lastname: e.target.value,
                              },
                            });
                          }}
                          placeholder={"Nom"}
                        />
                      </FormItem>
                      <FormItem {...formItemLayout} label="Prénom">
                        <Input
                          value={this.state.selectedUser.firstname}
                          onChange={(e) => {
                            this.setState({
                              selectedUser: {
                                ...this.state.selectedUser,
                                firstname: e.target.value,
                              },
                            });
                          }}
                          placeholder={"Prénom"}
                        />
                      </FormItem>
                      <FormItem {...formItemLayout} label="Email">
                        <Input
                          value={this.state.selectedUser.email}
                          onChange={(e) => {
                            this.setState({
                              selectedUser: {
                                ...this.state.selectedUser,
                                email: e.target.value,
                              },
                            });
                          }}
                          placeholder={"Email"}
                        />
                      </FormItem>
                      <FormItem {...formItemLayout} label="Newsletter">
                        <Checkbox
                          checked={this.state.selectedUser.newsletter !== false}
                          onChange={(e) => {
                            this.setState({
                              selectedUser: {
                                ...this.state.selectedUser,
                                newsletter: e.target.checked,
                              },
                            });
                          }}
                        >
                          Inscrit à la newsletter
                        </Checkbox>
                      </FormItem>
                      <FormItem {...formItemLayout} label="Groupe(s)">
                        <Select
                          value={this.state.selectedUser.group}
                          mode={"multiple"}
                          onChange={(e) => {
                            this.setState({
                              selectedUser: {
                                ...this.state.selectedUser,
                                group: e,
                              },
                            });
                          }}
                        >
                          {this.state.groupList.map((m) => {
                            return <Option value={m._id}>{m.title}</Option>;
                          })}
                        </Select>
                      </FormItem>
                      <FormItem {...formItemLayout} label="Téléphone fixe">
                        <Input
                          value={
                            this.state.selectedUser.phone &&
                            this.state.selectedUser.phone.fixe
                          }
                          onChange={(e) => {
                            this.setState({
                              selectedUser: {
                                ...this.state.selectedUser,
                                phone: {
                                  ...this.state.selectedUser.phone,
                                  fixe: e.target.value,
                                },
                              },
                            });
                          }}
                          placeholder={"Téléphone fixe"}
                        />
                      </FormItem>
                      <FormItem {...formItemLayout} label="Téléphone port">
                        <Input
                          value={
                            this.state.selectedUser.phone &&
                            this.state.selectedUser.phone.port
                          }
                          onChange={(e) => {
                            this.setState({
                              selectedUser: {
                                ...this.state.selectedUser,
                                phone: {
                                  ...this.state.selectedUser.phone,
                                  port: e.target.value,
                                },
                              },
                            });
                          }}
                          placeholder={"Téléphone portable"}
                        />
                      </FormItem>
                    </div>
                    <div className="societe">
                      <h5>Société</h5>
                      <hr />
                      <FormItem {...formItemLayout} label="Société">
                        {this.state.selectedUser.editName ? (
                          <Input
                            value={this.state.selectedUser.company.name}
                            onChange={(e) => {
                              this.setState({
                                selectedUser: {
                                  ...this.state.selectedUser,
                                  company: {
                                    ...this.state.selectedUser.company,
                                    name: e.target.value,
                                  },
                                },
                              });
                            }}
                            placeholder={"Nom de la société"}
                          />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Select
                              value={this.state.selectedUser.company._id}
                              onChange={(e) =>
                                this.setState({
                                  selectedUser: {
                                    ...this.state.selectedUser,
                                    company: this.state.companyList.filter(
                                      (c) => c._id == e
                                    )[0],
                                  },
                                })
                              }
                              placeholder={"Nom de la société"}
                            >
                              {this.state.companyList.map((f) => {
                                return <Option value={f._id}>{f.name}</Option>;
                              })}
                            </Select>
                            {this.state.selectedUser.company &&
                            this.state.selectedUser.company._id ? (
                              <Tooltip title="Modifier le nom">
                                <Button
                                  onClick={() =>
                                    this.setState({
                                      selectedUser: {
                                        ...this.state.selectedUser,
                                        editName: true,
                                      },
                                    })
                                  }
                                  style={{ marginLeft: "5px" }}
                                  icon="edit"
                                ></Button>
                              </Tooltip>
                            ) : (
                              ""
                            )}
                            <Tooltip title="Nouvelle société">
                              <Button
                                style={{ marginLeft: "5px" }}
                                onClick={() =>
                                  this.setState({
                                    selectedUser: {
                                      ...this.state.selectedUser,
                                      editName: true,
                                      company: {
                                        name: "",
                                        address: "",
                                        city: "",
                                        status: "passif",
                                      },
                                    },
                                  })
                                }
                                type="primary"
                                icon="plus-circle-o"
                              ></Button>
                            </Tooltip>
                          </div>
                        )}
                      </FormItem>
                      {this.state.selectedUser.company &&
                      (this.state.selectedUser.company._id ||
                        this.state.selectedUser.editName) ? (
                        <div>
                          <FormItem {...formItemLayout} label="Adresse">
                            <Input
                              value={this.state.selectedUser.company.address}
                              onChange={(e) => {
                                this.setState({
                                  selectedUser: {
                                    ...this.state.selectedUser,
                                    company: {
                                      ...this.state.selectedUser.company,
                                      address: e.target.value,
                                    },
                                  },
                                });
                              }}
                              placeholder={"Adresse de la société"}
                            />
                          </FormItem>
                          <FormItem {...formItemLayout} label="Ville">
                            <Input
                              value={this.state.selectedUser.company.city}
                              onChange={(e) => {
                                this.setState({
                                  selectedUser: {
                                    ...this.state.selectedUser,
                                    company: {
                                      ...this.state.selectedUser.company,
                                      city: e.target.value,
                                    },
                                  },
                                });
                              }}
                              placeholder={"Ville de la société"}
                            />
                          </FormItem>
                          <FormItem {...formItemLayout} label="Statut">
                            <Select
                              value={this.state.selectedUser.company.status}
                              onChange={(e) => {
                                this.setState({
                                  selectedUser: {
                                    ...this.state.selectedUser,
                                    company: {
                                      ...this.state.selectedUser.company,
                                      status: e,
                                    },
                                  },
                                });
                              }}
                            >
                              <Option value="actif">
                                <Badge status="success" /> Actif
                              </Option>
                              <Option value="passif">
                                <Badge status="warning" /> Passif
                              </Option>
                            </Select>
                          </FormItem>
                          <FormItem
                            style={{ marginBottom: "5px" }}
                            {...formItemLayout}
                            label="Logo"
                          >
                            <Upload
                              style={{ width: "100%" }}
                              fileList={this.state.fileList}
                              onRemove={(file) => this.onRemove(file)}
                              beforeUpload={(file) => this.beforeUpload(file)}
                              name="logo"
                            >
                              <Button style={{ width: "100%" }}>
                                <Icon type="upload" /> Sélectionner le logo de
                                la société
                              </Button>
                            </Upload>
                          </FormItem>
                          {this.state.typeModal == "edit" &&
                          this.state.selectedUser.company &&
                          this.state.selectedUser.company._id &&
                          this.props.user.company &&
                          this.props.user.company._id !==
                            this.state.selectedUser.company._id ? (
                            <Alert
                              type="warning"
                              showIcon
                              style={{ marginBottom: 16 }}
                              message="Suppression d’entreprise"
                              description={
                                <div>
                                  <p style={{ marginBottom: 10 }}>
                                    Cette action retire l’entreprise et ses utilisateurs des listes visibles, sans effacer définitivement les données.
                                  </p>
                                  <Button
                                    type="danger"
                                    loading={this.state.companyDeleteLoading}
                                    onClick={() =>
                                      this.showCompanyDeleteConfirm(
                                        this.state.selectedUser.company
                                      )
                                    }
                                  >
                                    Supprimer cette entreprise
                                  </Button>
                                </div>
                              }
                            />
                          ) : null}
                          {this.state.selectedUser.company.logo ||
                          this.state.fileList.length > 0 ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "15px",
                                boderRadius: "5px",
                                border: "1px dashed #d8d8d8",
                              }}
                            >
                              <img
                                width="100"
                                src={
                                  this.state.fileList.length == 0
                                    ? this.state.selectedUser.company.logo
                                    : this.state.preview
                                }
                                alt=""
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </Form>
                </Modal>
              </div>
            ) : (
              ""
            )}

            <Table
              rowClassName={(record, index) => record.company.status}
              pagination={{ pageSize: 8 }}
              locale={{ emptyText: "Aucune données" }}
              columns={this.state.columns}
              scroll={{ x: 1900 }}
              dataSource={this.state.data}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./components/table.js